export default __webpack_public_path__ + "static/process-bg-7a9aa527ecfc1fb551546045b2e48697.jpg";